/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Indicateinterest_Acknowledgment2Inputs */

const en_coinvestments_indicateinterest_acknowledgment2 = /** @type {(inputs: Coinvestments_Indicateinterest_Acknowledgment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand that this is an indicative amount and I am under no obligation to invest`)
};

/**
* | output |
* | --- |
* | "I understand that this is an indicative amount and I am under no obligation to invest" |
*
* @param {Coinvestments_Indicateinterest_Acknowledgment2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_indicateinterest_acknowledgment2 = /** @type {((inputs?: Coinvestments_Indicateinterest_Acknowledgment2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Indicateinterest_Acknowledgment2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_indicateinterest_acknowledgment2(inputs)
});
export { coinvestments_indicateinterest_acknowledgment2 as "coInvestments_indicateInterest_acknowledgment" }